import {
  primaryMain,
  orange800,
  neutral900,
  white,
  lead800,
  surfaceCard,
  ENABLE_WARM_WASH,
  warmWashBackgroundImage,
  layoutCardRadius,
} from './colors';

export const componentOverrides = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        margin: 0,
        backgroundColor: '#FEF6EF',
        ...(ENABLE_WARM_WASH && {
          backgroundImage: warmWashBackgroundImage,
        }),
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
      },
    },
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: primaryMain,
        textDecoration: 'none',
        '&:hover': {
          color: primaryMain,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },
  },
  MuiButtonBase: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.shadows[2],
        transition: theme.transitions.create('box-shadow', {
          duration: theme.transitions.duration.short,
        }),
        '&:hover': {
          boxShadow: theme.shadows[4],
        },
        '&:active': {
          boxShadow: theme.shadows[8],
        },
        '&[data-no-shadow="true"], &[data-no-shadow="true"]:hover, &[data-no-shadow="true"]:active': {
          boxShadow: 'none',
        },
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        margin: '4px',
        padding: '8px 16px',
      },
    },
    variants: [
      {
        props: { variant: 'outlined' },
        style: {
          color: primaryMain,
          borderColor: primaryMain,
          '&:hover': {
            backgroundColor: 'rgba(248, 150, 62, 0.1)',
            borderColor: primaryMain,
          },
        },
      },
      {
        props: { variant: 'contained' },
        style: {
          backgroundColor: primaryMain,
          color: white,
          '&:hover': {
            backgroundColor: orange800,
          },
        },
      },
      {
        props: { variant: 'contained', color: 'secondary' },
        style: {
          backgroundColor: neutral900,
          color: white,
          '&:hover': {
            backgroundColor: lead800,
          },
        },
      },
    ],
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: layoutCardRadius,
          '&:hover fieldset': {
            borderColor: primaryMain,
          },
          '&.Mui-focused fieldset': {
            borderColor: primaryMain,
          },
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: surfaceCard,
        borderRadius: layoutCardRadius,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: layoutCardRadius,
      },
    },
    variants: [
      {
        props: { variant: 'transparent' },
        style: {
          backgroundColor: 'transparent',
        },
      },
    ],
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        pageTitle: 'h1',
        sectionTitle: 'h2',
        storeName: 'p',
      },
    },
  },
};
